export default {
  SET_RECENT_CLASSES(state, classes) {
    state.recentClasses = classes
  },
  SET_RECENT_CLASSES_COUNT(state, data) {
    state.recentClassesCount = data
  },
}
